import React from "react";
import styled from "styled-components";
import swap from "../imgs/swap.svg";
import arrow from "../imgs/arrow.svg";
import FadeInLeft from "../animations/FadeInLeft";
import FadeInRight from "../animations/FadeInRight";

const Wrapper = styled.div`
  background: ${({ theme }) => theme.colors.blue};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  z-index: 3;
  position: relative;
  height: 51px;
`;

const Language = styled.div`
  text-align: ${props => (props.alignRight ? "right" : "left")};
  padding: 15px 40px 15px 20px;
  position: relative;
  width: 100%;
  overflow: hidden;
  cursor: ${props => (props.clickable) ? "pointer" : "normal"};
  img {
    width: 16px;
    position: absolute;
    ${props => (props.alignRight ? "left: 20px" : "right: 20px")};
    top: 50%;
    transform: translateY(-50%);
  }
`;

const Label = styled.p`
  color: ${({ theme }) => theme.colors.accent};
  font-size: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
  position: absolute;
  width: 105px;
  ${props => (props.right ? "right: 20px" : "left: 20px")};
`;

const Swap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 30px;
  }
`;

const renderLanguageSelector = (options, props) => {
  const Fade = options.alignRight ? FadeInRight : FadeInLeft;
  return (
    <Language
      alignRight={options.alignRight}
      onClick={props.toggleLanguageMenu}
      clickable={true}
    >
      <Fade>
        <Label key={props.label} right={options.alignRight}>
          {props.label}
        </Label>
      </Fade>
      <img src={arrow} alt="Select a language" />
    </Language>
  );
};

const renderGeordieSymbol = options => {
  const Fade = options.alignRight ? FadeInRight : FadeInLeft;
  return (
    <Language alignRight={options.alignRight}>
      <Fade>
        <Label right={options.alignRight}>Geordie</Label>
      </Fade>
    </Language>
  );
};

const LanguageMenu = props => {
  return (
    <Wrapper>
      {props.reversed
        ? renderGeordieSymbol({ alignRight: false })
        : renderLanguageSelector({ alignRight: false }, props)}
      <Swap onClick={props.swapSelectedLanguages}>
        <img src={swap} alt="Swap Languages" />
      </Swap>
      {props.reversed
        ? renderLanguageSelector({ alignRight: true }, props)
        : renderGeordieSymbol({ alignRight: true })}
    </Wrapper>
  );
};

export default LanguageMenu;



// WEBPACK FOOTER //
// ./src/components/LanguageMenu.js